import { Component, Input, OnInit } from '@angular/core';
import { Article, Sources } from './help-center-articles';

@Component({
  selector: 'app-help-search-card',
  templateUrl: './help-search-card.component.html',
  styleUrls: ['./help-search-card.component.scss'],
})
export class HelpSearchCardComponent implements OnInit {
  @Input() article: Article;
  icon: string;

  ngOnInit(): void {
    switch (this.article.source) {
      case Sources.ZD_COMMUNITY_POST:
        this.icon = 'groups';
        break;
      case Sources.ZD_RESOURCE_CENTER:
        this.icon = 'article';
        break;
      case Sources.CL_PODCAST:
        this.icon = 'podcasts';
        break;
      case Sources.CL_VIDEO:
        this.icon = 'videocam';
        break;
      case Sources.CL_GROUP:
        this.icon = 'group';
        break;
      case Sources.OPEN_API:
        this.icon = 'api';
        break;
      default:
        this.icon = 'book';
        break;
    }
  }

  openArticle(): void {
    window.open(this.article.link, '_blank', 'noopener');
  }
}
